<template>
  <div>
    <div class="task container-dropzone">
      <!-- <label> {{ task.label }} </label> -->
      <div id="uploadFile" :class="['w3-right', {'loading': loading}, {'active': dragEnter}]"
        @dragover.prevent="dragEnter = true"
        @dragleave.prevent="dragEnter = false"
        @drop.prevent="handleDrop"
        @click="$refs.fileInput.click()"
      >
        <input
          ref="fileInput"
          type="file"
          :accept="dropzoneOptions.acceptedFiles"
          style="display:none"
          @change="handleFileInput"
        />
        <div id="dropzone" v-html="dropzoneOptions.dictDefaultMessage" />
      </div>
      <div class="dz-preview dz-file-preview">
        <transition name="fade" mode="out-in">
          <div v-if="!loading" class="dz-details">
            <div class="dz-filename"><span data-dz-name></span></div>
            <div class="dz-size" data-dz-size></div>
          </div>
          <div v-else class="taskFileLoading-overlay">
            <spinner-loading class="taskFileLoading" :size="22" />
            <span class="taskFileLoading-text">
              <template v-if="uploadProgress < 100">{{ getLang('dictUploading') }}<br />{{ uploadProgress }}%</template>
              <template v-else>{{ getLang('dictProcessing') }}</template>
            </span>
          </div>
        </transition>
      </div>
      <transition-group name="fade">
        <div v-if="dzError && dzError !== '' && dzErrorShow" class="dz-error-message label error_validate" key="error-msg">
          <span data-dz-errormessage="" v-html="dzError"></span>
          <i class="sherpa-icon icon-cerrar" @click="hideDzError"></i>
        </div>
        <div v-else-if="taskResp && taskResp !== ''" class="label error_validate oky_validate" key="ok-msg">
          <span> {{ taskResp }} </span>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue'
import language from '../../language'

export default {
  name: 'definition-task-file',
  components: {
    SpinnerLoading
  },
  props: [
    'task',
    'definition',
    'definitionContentId',
    'repeatableGroupCode',
    'object',
    'taskRefresh',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'callTask'
  ],
  data () {
    return {
      loading: false,
      uploadProgress: 0,
      taskError: false,
      taskResp: '',
      dropzoneOptions: this.getDropzoneOptions(),
      mimeTypes: this.getMimeTypes(),
      dzError: '',
      dzErrorShow: false,
      languageLoaded: true,
      dragEnter: false
    }
  },
  methods: {
    handleDrop (event) {
      this.dragEnter = false
      const file = event.dataTransfer.files[0]
      if (file) this.processFile(file)
    },
    handleFileInput (event) {
      const file = event.target.files[0]
      if (file) this.processFile(file)
    },
    processFile (file) {
      if (!this.checkFileSize(file.size)) {
        this.dzError = this.getFileTooBigMessage(file.size)
        this.dzErrorShow = true
      } else if (this.checkFileExtension(file.type)) {
        this.dzError = null
        this.dzErrorShow = false
        this.loading = true
        this.taskResp = null
        this.uploadFileManually(file)
      } else {
        this.dzError = this.getLang('errorRegExp')
        this.dzErrorShow = true
      }
    },
    // Guard aditivo de tamaño: si la task no tiene lengthMax configurado, no valida.
    checkFileSize (fileSizeBytes) {
      var lengthMax = this.task.validation.format.lengthMax
      if (lengthMax == null || lengthMax <= 0) {
        return true
      }
      return fileSizeBytes <= lengthMax // bytes vs bytes (lengthMax viene en bytes)
    },
    getFileTooBigMessage (fileSizeBytes) {
      var mb = 1024 * 1024
      var fileSizeMB = (fileSizeBytes / mb).toFixed(1)
      var maxFilesizeMB = Math.round(this.task.validation.format.lengthMax / mb)
      // dictFileTooBig trae placeholders de DOBLE llave {{...}}; el helper language()
      // solo sustituye llave simple, así que los reemplazamos a mano.
      return this.getLang('dictFileTooBig')
        .replace('{{filesize}}', fileSizeMB)
        .replace('{{maxFilesize}}', maxFilesizeMB)
    },
    setLanguageLoaded () {
      this.languageLoaded = true
    },
    getCurrentLanguage () {
      var result = null
      if (this.languageSelected) {
        result = this.languageSelected.key
      }
      if (!result) {
        result = this.getLang('isoCode')
      }
      return result
    },
    getDropzoneIcon () {
      var result = ''
      var regExp = this.task.validation.format.regExp

      if (regExp === '.zip') {
        result = 'icon-zip'
      } else if (regExp === '.jpg' || regExp === '.png' || regExp === '.gif') {
        result = 'icon-imagen'
      } else {
        result = 'icon-copy'
      }

      return result
    },
    checkFileExtension (fileType) {
      var result = false
      var fileExtensions = this.task.validation.format.regExp.split(',')
      for (var i = 0; i < this.mimeTypes.length && !result; i++) {
        var mimeType = this.mimeTypes[i]
        for (var k = 0; k < fileExtensions.length && !result; k++) {
          if (mimeType.id === fileExtensions[k]) {
            for (var j = 0; j < mimeType.mimes.length && !result; j++) {
              if (mimeType.mimes[j] === fileType) {
                result = true
              }
            }
          }
        }
      }
      return result
    },
    getFileName (filename) {
      const lastDotIndex = filename.lastIndexOf('.')
      return lastDotIndex !== -1 ? filename.substring(0, lastDotIndex) : 'filename'
    },
    getFileExtension (filename) {
      const lastDotIndex = filename.lastIndexOf('.')
      return lastDotIndex !== -1 ? filename.substring(lastDotIndex + 1) : 'extension'
    },
    getDropzoneOptions () {
      var taskUrl = this.type.domainEndpoint
      if (this.type.taskDomainEndpoint) {
        taskUrl += this.type.taskDomainEndpoint
      }
      taskUrl += this.task.type.endpoint

      // Pista de tamaño máximo (dinámica desde lengthMax; vacía si no hay límite)
      var lengthMax = this.task.validation.format.lengthMax
      var maxHint = ''
      if (lengthMax != null && lengthMax > 0) {
        var maxMB = Math.round(lengthMax / (1024 * 1024))
        maxHint = '<span style="position:absolute;top:80px;left:0;width:100%;text-align:center;font-size:10px;color:#333;opacity:.75;">' + this.getLang('dictMaxSizeLabel') + ' ' + maxMB + ' MB</span>'
      }

      return {
        timeout: 30 * 60 * 1000,
        url: taskUrl,
        maxFilesize: this.task.validation.format.lengthMax / (1024 * 1024), // bytes / (1024 * 1024) --> MB
        acceptedFiles: this.task.validation.format.regExp,
        uploadMultiple: false,
        clickable: true,
        createImageThumbnails: false,
        autoProcessQueue: false,
        dictFallbackMessage: this.getLang('dictFallbackMessage'),
        dictFallbackText: this.getLang('dictFallbackText'),
        dictFileTooBig: this.getLang('dictFileTooBig'),
        dictInvalidFileType: this.getLang('dictInvalidFileType'),
        dictResponseError: this.getLang('dictResponseError'),
        dictCancelUpload: this.getLang('dictCancelUpload'),
        dictCancelUploadConfirmation: this.getLang('dictCancelUploadConfirmation'),
        dictRemoveFile: this.getLang('dictRemoveFile'),
        dictRemoveFileConfirmation: null,
        dictMaxFilesExceeded: this.getLang('dictMaxFilesExceeded'),
        dictDefaultMessage: '<p><i class="sherpa-icon ' + this.getDropzoneIcon() + '" style="position:absolute;top:16px;left:0;right:0;text-align:center;font-size:2.1em;color:#333;"></i><br><span style="font-style:italic;position:absolute;top:58px;left:0;font-size:12px;color:#333;text-align:center;font-weight:500;padding:3px;width:100%;">' + this.task.label + '</span>' + maxHint + '</p>',
      }
    },
    uploadFileManually (file) {
      const formData = new FormData()
      formData.append('files', file)
      formData.set('id', this.definitionContentId)
      formData.set('code', this.repeatableGroupCode)
      formData.set('lang', this.getCurrentLanguage())

      this.uploadProgress = 0

      // Usamos XMLHttpRequest (no fetch) porque es el único que da progreso de
      // SUBIDA (upload.onprogress) y permite timeout; así el usuario ve que está
      // trabajando y no parece colgado.
      const xhr = new XMLHttpRequest()
      xhr.open('POST', this.dropzoneOptions.url, true)
      xhr.setRequestHeader('authorization', this.authorization)
      xhr.responseType = 'blob'
      xhr.timeout = 10 * 60 * 1000 // 10 min: evita quedar colgado indefinidamente

      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          this.uploadProgress = Math.round((e.loaded / e.total) * 100)
        }
      }

      xhr.onload = async () => {
        this.loading = false
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const contentType = xhr.getResponseHeader('Content-Type')
            const blob = xhr.response

            // tsres
            if (contentType && contentType.includes('application/json')) {
              const jsonResponse = JSON.parse(await blob.text())
              if (jsonResponse.requestResult) {
                this.taskResp = jsonResponse.requestResultSuccess
                if (jsonResponse.requestObject) {
                  var ro = jsonResponse.requestObject[0]
                  // Adjuntamos una URL local del fichero recién subido para poder ABRIRLO
                  // antes de guardar el documento (aún no está en BD). Campo transitorio,
                  // el padre (file.vue) lo guarda aparte y no se persiste.
                  try {
                    ro.localFileUrl = window.URL.createObjectURL(file)
                    ro.localFileName = file.name
                  } catch (e) { /* createObjectURL no disponible: se ignora */ }
                  this.$emit('refreshDefinition', ro)
                }
              } else {
                if (jsonResponse.requestResultError && jsonResponse.requestResultError.requestErrorMsg) {
                  this.dzError = jsonResponse.requestResultError.requestErrorMsg.replace(/(?:\r\n|\r|\n)/g, '<br />')
                } else {
                  this.dzError = this.getLang('error500header')
                }
                this.dzErrorShow = true
              }

            // file
            } else {
              var fileDownload = require('js-file-download')
              fileDownload(blob, this.getFileName(file.name) + '.validated.' + this.getFileExtension(file.name))
              this.taskResp = this.getLang('fileDownloaded')
            }
          } catch (err) {
            console.error('Error procesando la respuesta de subida:', err)
            this.dzError = this.getLang('error500header')
            this.dzErrorShow = true
          }

        // 413: el fichero supera el límite del servidor/proxy (p. ej. Cloudflare o nginx)
        } else if (xhr.status === 413) {
          this.dzError = this.getLang('dictUploadTooLarge')
          this.dzErrorShow = true

        // resto de errores HTTP
        } else {
          this.dzError = this.getLang('dictResponseError').replace('{{statusCode}}', xhr.status || '—')
          this.dzErrorShow = true
        }
      }

      // Error de red (conexión cortada por el proxy, etc.)
      xhr.onerror = () => {
        console.error('Error de red al subir el fichero')
        this.loading = false
        this.dzError = this.getLang('dictUploadFailed')
        this.dzErrorShow = true
      }

      // Tiempo de espera agotado
      xhr.ontimeout = () => {
        this.loading = false
        this.dzError = this.getLang('dictUploadFailed')
        this.dzErrorShow = true
      }

      xhr.send(formData)
    },
    getMimeTypes () {
      return [
        {
          id: '.zip',
          mimes: [
            'application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip'
          ]
        },
        {
          id: '.rar',
          mimes: [
            'application/x-rar-compressed', 'application/octet-stream'
          ]
        },
        {
          id: '.jpg',
          mimes: [
            'image/jpeg', 'image/jpg'
          ]
        },
        {
          id: '.png',
          mimes: [
            'image/png'
          ]
        },
        {
          id: '.gif',
          mimes: [
            'image/gif'
          ]
        },
        {
          id: '.docx',
          mimes: [
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          ]
        },
        {
          id: '.xls',
          mimes: [
            'application/vnd.ms-excel'
          ]
        },
        {
          id: '.xlsx',
          mimes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ]
        },
        {
          id: '.xlsm',
          mimes: [
            'application/vnd.ms-excel.sheet.macroEnabled.12'
          ]
        },
        {
          id: '.xlsb',
          mimes: [
            'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
          ]
        },
        {
          id: '.pptx',
          mimes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation'
          ]
        },
        {
          id: '.pdf',
          mimes: [
            'application/pdf'
          ]
        }
      ]
    },
    getLang (key) {
      return language(this.language, key)
    },
    hideDzError () {
      this.dzErrorShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
#uploadFile {
  position: relative;
  width: 100%;
  height: 100px;
  background-color: #ff7543cb;
  border-radius: 5px;
  border: 1px dashed #666;

  #dropzone {
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
#uploadFile:hover,
#uploadFile.active {
  background-color: #ff7643;
}
.error_validate.oky_validate {
  color: green !important;
  padding-top: 15px !important;
  text-align: center;
  position: static;
  font-size: 13px !important;
}
</style>

<style lang="scss">
/* .dropzone .dz-preview .dz-error-message, */
.dropzone .dz-preview .dz-success-mark,
.dropzone .dz-preview .dz-error-mark,
.dropzone .dz-preview .dz-progress,
.dropzone .dz-preview .dz-image,
.dropzone .dz-preview .dz-size {
  display: none !important;
}

.dropzone .dz-preview .dz-details,
.dz-preview.dz-file-preview {
  position: relative;

  .dz-filename,
  .dz-size {
    font-stretch: normal;
    line-height: 1.1;
    letter-spacing: normal;
    position: absolute;
    top: 60px;
    font-style: italic;
    font-weight: 400;
    padding: 0;
    font-size: 0.9em;
    margin-bottom: 2px;
    color: green;
    width: auto;
  }

  .taskFileLoading {
    position: relative;
    left: 0;
    right: 0;
    top: 40px;
    bottom: 0;
  }

  .dz-filename {
    top: 80px;
    display: none;
  }
}

/* Overlay de subida: centrado sobre toda la zona de drop (no la cajita de preview) */
.task.container-dropzone {
  position: relative;
}

.taskFileLoading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px; /* = alto del dropzone #uploadFile */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.88);
  border-radius: 8px;
  z-index: 50;

  .taskFileLoading {
    position: static !important;
    top: auto !important;
    left: auto;
    right: auto;
  }

  .taskFileLoading-text {
    width: 100%;
    padding: 0 8px;
    font-size: 11px;
    font-weight: 500;
    font-style: normal;
    color: #333;
    line-height: 1.35;
    text-align: center;
  }
}

.image {
  .dropzone .dz-preview .dz-details,
  .dz-preview.dz-file-preview {
    .taskFileLoading {
      top: 38px !important;
    }
  }
}

.loading {
  .dz-message {
    display: none;
  }
}

.label.error_validate.dz-error-message {
  position: static;
  padding: 15px 10px 10px 10px !important;
  border-radius: 4px;
  border: 1px dotted #999;
  z-index: 100000;
  background-color: #fff;
  cursor: default;
  min-height: 50px;
  overflow-y: auto;
  width: 100%;

  .icon-cerrar {
    color: #ff7643;
    right: 22px;
    bottom: 127px;
    cursor: pointer;
    transition: all 0.2s ease-in;
    font-size: 12px;
    margin-right: 0;
  }
  .icon-cerrar:hover {
    color: #ffcc00;
  }
}
</style>
